async function executeQuery(query,variables,apiVersion='2023-04'){
    const header={
        'Content-Type': 'application/json',
        "X-Shopify-Storefront-Access-Token":"dd4accc79cf5bc2ec51edb780c786fca"
    };
    const url = `https://nalishop-it.myshopify.com/api/${apiVersion}/graphql.json`;
    try{
        const response = await fetch(url,{
            method:"POST",
            headers:header,
            body:JSON.stringify({
                query,
                variables
            })
        })
        return response.json();
    }
    catch(error){
        return {error,status:false};
    }
}